import { alpha } from "@material-ui/core"
import { nodePalette } from "../../../../../theme"
import simpleCircleGraphics from "../../../../graphics/SimpleCircleGraphics"
import MagicClone from "../../../../physics/magic/MagicClone"
import ManaParticle from "../../../ManaParticle"
import NodeCategories from "../../NodeCategories"
import SimpleManaNode, { SimpleManaNodeOptions } from "../../SimpleManaNode"
import CloneManaSource from "../unique/CloneManaSource"

export type CloneNodeOptions = {} & SimpleManaNodeOptions

export default class CloneNode extends SimpleManaNode {

	static nodeType = 'CloneNode'
	static nodeName = "Clone node"
	static nodeDesc = "Create a clone of the caster, splitting the casters mana"
	static nodeIcon = '🐱‍👤'
	static category = NodeCategories.Element

	async act(particle: ManaParticle) {

		const halfMana = particle.source.mana / 2

		particle.source.consumeMana(halfMana)

		const clone = new MagicClone({
			world: particle.target.world,

			x: particle.target.position.x,
			y: particle.target.position.y,

			health: 5,
			maxHealth: 5,
		})

		const cloneSource = new CloneManaSource({
			world: this.world,
			infinite: particle.source.infinite,
			mana: halfMana,
			maxMana: halfMana,
			regen: 0,
			particleCooldown: particle.source.particleCooldown,
			clone
		})

		clone.symbol = particle.caster.symbol

		cloneSource.getViableRoutes = this.getViableRoutes.bind(this)

		particle.target.world.add(clone)

		particle.target = clone

		return false
	}

	createGraphics() {
		const graphics = simpleCircleGraphics({
			obj: this,
			x: this.position.x,
			y: this.position.y,
			size: this.size,
			symbol: this.symbol,
			color: this.color,
			border: () => {
				if (this.particles.length) return nodePalette.active
				return this.particleIndicationCooldown ? alpha(nodePalette.active, this.particleIndicationCooldown / this.maxParticleIndicationCooldown) : nodePalette.border
			},
			evented: true,
		})

		return graphics
	}

}